var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeadline28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 1.5a.5.5 0 0 0-1 0V4H2.5a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 0-1H3V9h21v2.5a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-.5-.5H19V1.5a.5.5 0 0 0-1 0V4H9V1.5ZM24 8V5H3v3h21ZM14 18.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4.5-5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm.5 3.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 0-1H19v-1.5Z",
  clipRule: "evenodd"
})));
export { SvgDeadline28 as ReactComponent };
export default __webpack_public_path__ + "54b98faf387859a1f0a02f9814a0ad2e.svg";